const scrollToFooter = () => {
    const footer = document.getElementById('footer-main-container');
    if (footer) {
        footer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
};
export default scrollToFooter;
